import type { MovementError } from "@features/vessel-call/vessel-call-status/MovementServices/form/utils.ts";
import type { CloseMovementServicePayload } from "@services/movement-services/types";
import { closeMovementServiceById } from "@services/movementServicesApi";
import { useMutation } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";

export const useCloseMovementService = ({
  handleSuccess,
  handleError,
}: {
  handleSuccess: () => void;
  handleError: (error: MovementError) => void;
}) => {
  const closeMovementServiceMutation = useMutation({
    mutationFn: (variables: Parameters<typeof closeMovementServiceById>[0]) =>
      runTransaction(
        {
          module: "vessel_call",
          screen: "CloseMovementService",
          action: "close_movement_service",
          entityType: "movement_service",
        },
        (transactionId) =>
          closeMovementServiceById({ ...variables, ...(transactionId ? { transactionId } : {}) }),
      ),
    onSuccess: () => handleSuccess(),
    onError: (error: MovementError) => handleError(error),
  });

  const closeMovementService = async ({
    id,
    service,
    payload,
  }: {
    id: string;
    service: string;
    payload: CloseMovementServicePayload;
  }) => {
    closeMovementServiceMutation.mutate({
      id,
      service,
      payload,
    });
  };

  return {
    closeMovementService,
    isSubmitting: closeMovementServiceMutation.isPending,
  };
};
